import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { useFormState } from 'react-use-form-state';
import { FormLabel, Input, Select, Flex, Box } from '@chakra-ui/react';
import { CheckoutContext } from '../../context/Checkout';
import { Form } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Address = _ref => {
  let {
    addressType,
    shippingCountries
  } = _ref;
  const {
    shippingAddress,
    setShippingAddress,
    invoiceAddress,
    setInvoiceAddress
  } = useContext(CheckoutContext);
  const initialState = () => {
    if (addressType === 'shipping' && shippingAddress) {
      const sa = _objectSpread({}, shippingAddress);
      delete sa.address_type;
      return sa;
    } else if (addressType === 'invoice' && invoiceAddress) {
      const ia = _objectSpread({}, invoiceAddress);
      delete ia.address_type;
      return ia;
    } else {
      return {
        country: shippingCountries[0].country_id.id
      };
    }
  };
  const [formState, {
    text,
    label,
    number,
    select
  }] = useFormState(initialState(), {
    withIds: true
  });
  const onSave = async () => {
    const {
      surname,
      name,
      company,
      street,
      addition,
      zip,
      city,
      country,
      phone
    } = formState.values;
    const addressStructure = {
      address_type: addressType,
      surname,
      name,
      company,
      street,
      addition,
      zip,
      city,
      country,
      phone
    };
    if (addressType === 'shipping') {
      setShippingAddress(addressStructure);
    } else if (addressType === 'invoice') {
      setInvoiceAddress(addressStructure);
    }
  };
  const onBlur = e => {
    e.preventDefault();
    onSave();
  };
  return ___EmotionJSX(Form, null, ___EmotionJSX("div", null, ___EmotionJSX(Flex, {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: "center"
  }, ___EmotionJSX(Box, {
    width: ['100%', '48%', '48%', '48%']
  }, ___EmotionJSX(FormLabel, label('name'), "Vorname*", ___EmotionJSX(Input, _extends({
    className: formState.validity.name ? 'valid' : null
  }, text({
    name: 'name',
    onBlur: e => onBlur(e)
  }), {
    required: true
  })))), ___EmotionJSX(Box, {
    width: ['100%', '48%', '48%', '48%']
  }, ___EmotionJSX(FormLabel, label('surname'), "Nachname*", ___EmotionJSX(Input, _extends({
    className: formState.validity.surname ? 'valid' : null
  }, text({
    name: 'surname',
    onBlur: e => onBlur(e)
  }), {
    required: true
  })))))), ___EmotionJSX("div", null, ___EmotionJSX(FormLabel, label('company'), "Firma", ___EmotionJSX(Input, _extends({
    className: formState.validity.company ? 'valid' : null
  }, text({
    name: 'company',
    onBlur: e => onBlur(e)
  }))))), ___EmotionJSX("div", null, ___EmotionJSX(FormLabel, label('street'), "Stra\xDFe und Hausnummer*", ___EmotionJSX(Input, _extends({
    className: formState.validity.street ? 'valid' : null
  }, text({
    name: 'street',
    onBlur: e => onBlur(e)
  }), {
    required: true
  })))), ___EmotionJSX("div", null, ___EmotionJSX(FormLabel, label('addition'), "Adresszusatz", ___EmotionJSX(Input, _extends({
    className: formState.validity.addition ? 'valid' : null
  }, text({
    name: 'addition',
    onBlur: e => onBlur(e)
  }))))), ___EmotionJSX("div", null, ___EmotionJSX(Flex, {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: "center"
  }, ___EmotionJSX(Box, {
    width: ['100%', '48%', '48%', '48%']
  }, ___EmotionJSX(FormLabel, label('zip'), "Postleitzahl*", ___EmotionJSX(Input, _extends({
    className: formState.validity.zip ? 'valid' : null
  }, text({
    name: 'zip',
    onBlur: e => onBlur(e)
  }), {
    required: true
  })))), ___EmotionJSX(Box, {
    width: ['100%', '48%', '48%', '48%']
  }, ___EmotionJSX(FormLabel, label('city'), "Stadt*", ___EmotionJSX(Input, _extends({
    className: formState.validity.city ? 'valid' : null
  }, text({
    name: 'city',
    onBlur: e => onBlur(e)
  }), {
    required: true
  })))))), ___EmotionJSX("div", null, ___EmotionJSX(FormLabel, label('country'), "Land*", ___EmotionJSX(Select, _extends({
    className: formState.validity.country ? 'valid' : null
  }, select({
    name: 'country',
    onBlur: e => onBlur(e)
  }), {
    required: true
  }), shippingCountries.map(country => ___EmotionJSX("option", {
    value: country.country_id.id,
    key: country.country_id.id
  }, country.country_id.display_name))))), ___EmotionJSX("div", null, ___EmotionJSX(FormLabel, label('phone'), "Telefonnummer", ___EmotionJSX(Input, _extends({
    className: formState.validity.email ? 'valid' : null
  }, number({
    name: 'phone',
    onBlur: e => onBlur(e)
  }))))));
};
export default Address;